angular.module('pitch.app').controller('HomeCtrl',
    function($scope, Content, SiteContext, featuredPlaylists, statementSlides, ContentsLoader) {

        "use strict";

        // ------
        // STATEMENT

        $scope.statementSlides = statementSlides;
        $scope.featuredPlaylists = featuredPlaylists;

        // ------
        // SONGWITERS

        var isSongwritersLoaded = false;

        $scope.loadSongwriters = function() {
            // The in-view directive seems to fire multiple times
            // make sure we only load latest data once.
            if (isSongwritersLoaded) {
                return;
            }

            isSongwritersLoaded = true;

            SiteContext.get().then(function(r) {
                Content.query({
                    sortField: 'slot',
                    sortOrder: 'ASC',
                    featured: true,
                    section: 'home/featured-songwriters, home/featured-songwriters:sites/' + r.id,
                    pageSize: 8
                }, function(resp) {
                    $scope.songwriters = resp;
                });
            });
        };

        // ------
        // LATEST

        var isLatestLoaded = false;

        $scope.loadLatest = function() {
            // The in-view directive seems to fire multiple times
            // make sure we only load latest data once.
            if (isLatestLoaded) {
                return;
            }

            isLatestLoaded = true;

            SiteContext.get().then(function(r) {
                Content.query({
                    sortField: 'slot',
                    sortOrder: 'ASC',
                    featured: true,
                    section: 'home/featured-content, home/featured-content:sites/' + r.id,
                    pageSize: 9
                }, function(resp) {
                    $scope.latest = resp;
                }, function() {
                    isLatestLoaded = false;
                });
            });
        };

        // ------
        // FEATURED TRACKS

        var isFeaturedTracksLoaded = false;

        $scope.loadFeaturedTracks = function() {
            // The in-view directive seems to fire multiple times
            // make sure we only load latest data once.
            if (isFeaturedTracksLoaded) {
                return false;
            }

            isFeaturedTracksLoaded = true;

            SiteContext.get().then(function(r) {
                $scope.featuredTracksLoader = new ContentsLoader({
                    sortField: 'slot',
                    sortOrder: 'ASC',
                    featured: true,
                    section: 'home/featured-tracks, home/featured-tracks:sites/' + r.id,
                    pageSize: 25
                }).getAll();
            });
        };
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/HomeCtrl.js